export default {
    data() {
        return {
            current_user_read_only: JSON.parse(document.querySelector('body').dataset.currentUserReadOnly),
        }
    }
}